module.exports = __webpack_public_path__ + "img/ico-sns-kakao.37dbe46c.svg";